/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

const IconFacebook = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 270 270" xmlSpace="preserve">
    <path
      style={{ fill: '#A0A0A0' }}
      d="M253.7,1.5H16.3C8.1,1.5,1.5,8.1,1.6,16.3v237.3c0,8.1,6.6,14.7,14.7,14.7h127.8V165.1h-34.8v-40.3h34.8V95.1c0-34.4,21-53.2,51.8-53.2c10.4,0,20.8,0.5,31.1,1.6v36h-21.3c-16.8,0-20,7.9-20,19.6v25.7h39.9l-5.2,40.3h-34.7v103.2h68c8.1,0,14.7-6.6,14.7-14.7V16.2C268.4,8.1,261.8,1.5,253.7,1.5z"
    />
  </svg>
);
IconFacebook.propTypes = {};

export default IconFacebook;
